<template>
  <div class="footer">
    <div class="contain">
      <div class="content">
        <el-popover placement="top" trigger="hover">
          <div class="ewm">
            <p>关注微信公众号</p>
            <img :src="wxcode" alt="" />
          </div>
          <img
            class="icon"
            slot="reference"
            src="@/assets/images/footer-1.png"
            alt=""
          />
        </el-popover>
        <el-popover placement="top" trigger="hover">
          <div class="ewm">
            <p>微信扫码进入皂富鹅</p>
            <img src="@/assets/images/ewm.png" alt="" />
          </div>
          <img
            class="icon"
            slot="reference"
            src="@/assets/images/footer-2.png"
            alt=""
          />
        </el-popover>
        <p>
          风险提示：皂富鹅里任何用户或嘉宾的发言，都有其特定立场，投资决策需要建立在独立思考之上
        </p>
        <p>
          其他建议反馈欢迎点击
          <el-popover placement="top" trigger="hover">
            <div class="ewm">
              <p>提交您的建议</p>
              <!-- 这里可以添加建议表单或二维码 -->
              <img :src="Suggestion" alt="" />
            </div>
            <span slot="reference" style="color: #cf0f0f; cursor: pointer">
              #我给皂富鹅提建议#
            </span>
          </el-popover>
        </p>
        <p>© 2025 皂富鹅 杭州小财迷科技有限公司</p>
        <p>常见问题 |<span @click="join"> 加入我们</span> | 关于皂富鹅</p>
      </div>
    </div>
  </div>
</template>
<script>
import { getConfig } from "@/api/user.js";
export default {
  data() {
    return {
      wxcode: "",
      Suggestion: "",
    };
  },
  mounted() {
    this.make();
    this.make2();
  },
  methods: {
    async make() {
      getConfig({
        name: "config_qr_mp",
      }).then((res) => {
        if (res.success) {
          this.wxcode = res.data;
        }
      });
    },
    async make2() {
      getConfig({
        name: "config_admin_qr",
      }).then((res) => {
        if (res.success) {
          this.Suggestion = res.data;
          // console.log("Suggestion",tes.data)
        }
      });
    },
    join() {
      window.open(
        "https://www.zhipin.com/gongsi/d5aa6868070ea4b21n1y3dS6EVo~.html"
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 216px;
  background: #f1f2f5;
  padding: 30px 0;
  box-sizing: border-box;

  //   position: sticky;
  //   bottom: 0;
  .contain {
    width: 1120px;
    margin: 0 auto;

    .content {
      margin: 0 auto;
      text-align: center;
      color: #8e8e8e;
      font-size: 14px;
      img {
        margin: 10px;
      }
      p {
        margin: 3px 0;
        span {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.ewm {
  padding: 14px;

  text-align: center;

  img {
    margin-top: 16px;
    width: 100px;
  }
}
</style>
<style lang="scss" scoped>
.icon {
  height: 32px;
  width: 32px;
}
</style>
